export default {
  'Público': 1,
  'Privado': 2,
}
